import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../../../lib/apiClient';

export const QUERY_KEY_GET_SAVED_AUTOMATION_TARGETS =
  'saved-automation-targets';

export const useGetSavedAutomationTargets = ({
  queueId,
}: {
  queueId: number | undefined;
}) => {
  return useQuery({
    queryKey: [QUERY_KEY_GET_SAVED_AUTOMATION_TARGETS, queueId],
    queryFn: () => {
      if (queueId === undefined) throw new Error('Queue ID is undefined');
      return api.request(endpoints.queues.getAutomationTargets(queueId));
    },
    select: data => data.results,
    enabled: queueId !== undefined,
  });
};
